import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './MarketPricingDetails.scss';

class MarketPricingDetails extends Component {
  static propTypes = {
    jobsPricedPercentage: PropTypes.any,
    priceJobClick: PropTypes.func,
    adHocPricingClick: PropTypes.func,
    pricingYear: PropTypes.number,
    launchDarklyFeatureFlags: PropTypes.object,
    permissions: PropTypes.object
  };

  render() {
    let jobsPricedPct = this.props.jobsPricedPercentage >= 0 ? this.props.jobsPricedPercentage : '-';
    jobsPricedPct = jobsPricedPct > 0 && jobsPricedPct < 1 ? '< 1' : jobsPricedPct;
    return (
      <div className="db-marketpricing__details">
        <div className="marketpricing__details-priced">{jobsPricedPct}%</div>
        <div className="marketpricing__details--survey-year">Current Pricing Year: {this.props.pricingYear}</div>
      </div>
    );
  }
}
export default MarketPricingDetails;
